import React from "react";

const TooltipComponent = ({ children, name, position = "top"}) => {
  return (
    <div className="tooltip-wrapper">
      {children}
      <div className={`${name?.length>35 ? "tooltip-text-max":"tooltip-text"} tooltip-${position}`}>{name}</div>
    </div>
  );
};

export default TooltipComponent;
